/**
 * SC-11595 — customer names flow downstream to provisioning systems
 * (GLDS / BroadHub) that read order payloads as single-byte text, so
 * unexpected characters arrive as mojibake (e.g. en dash U+2013 became
 * "â€“") and break provisioning.
 *
 * Name fields are therefore constrained to the English and French
 * alphabets plus the punctuation that occurs in real names (space,
 * hyphen, apostrophe, period). Disallowed characters are stripped as the
 * user types so they never reach form state — no folding, no error.
 * Separators may not repeat back-to-back ("--", "..", "''", "  "), so a
 * run of the same separator collapses to a single one.
 */

// Letters of the French alphabet (accented vowels, the c-cedilla and the
// æ / œ ligatures), both cases. English A–Z / a–z are added in the regex.
const FRENCH_LETTERS = 'ÀÂÆÇÉÈÊËÎÏÔŒÙÛÜŸàâæçéèêëîïôœùûüÿ';

// Anything that is NOT an allowed name character. Allowed: English
// letters, French letters, space, period, apostrophe, hyphen.
const DISALLOWED_NAME_CHARACTERS = new RegExp(`[^A-Za-z${FRENCH_LETTERS} .'-]`, 'g');

// A separator (space, period, apostrophe, hyphen) immediately repeated —
// captured once and matched again via the back-reference so "Test--ing"
// and "Anna  Marie" collapse to a single separator.
const REPEATED_SEPARATORS = /([ .'-])\1+/g;

/**
 * Strips every character that is not allowed in a customer name and
 * collapses repeated separators. The value is NFC-normalized first so
 * decomposed accents (a base letter followed by a combining mark) collapse
 * into their precomposed form before filtering — otherwise the bare
 * combining mark would be stripped and the accent lost.
 */
export const sanitizeNameInput = (value: string): string =>
  value.normalize('NFC').replace(DISALLOWED_NAME_CHARACTERS, '').replace(REPEATED_SEPARATORS, '$1');
